import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { EncrdecrService } from '../Auth/encrdecr.service';
import { CustomLoaderService } from '../services/custom-loader.service';
import { LoginService } from '../services/login.service';
import { MainHeaderMenuService } from '../services/main-header-menu.service';
declare var $: any;
@Component({
  selector: 'app-client-pdfscheduler',
  templateUrl: './client-pdfscheduler.component.html',
  styleUrls: ['./client-pdfscheduler.component.scss']
})
export class ClientPdfschedulerComponent implements OnInit {
  Urldata: any;
  IsOptimoney: boolean = environment.IsOptimoney;
  constructor(
    private EncrdecrService: EncrdecrService,
    private LoginService: LoginService,
    private router: Router,
    public ShowHideHeaderMenu: MainHeaderMenuService,
    private Loader: CustomLoaderService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    debugger;

    this.route.queryParams.subscribe((queryparam) => {
      if (
        queryparam['Username'] &&
        queryparam['Password'] &&
        queryparam['SB_ID']
      ) {
        // login with Data
        let Username_Subrroker = queryparam['Username'].split('-');
        let LoginJson = {
          Username: Username_Subrroker[1],
          Password: this.EncrdecrService.getDecr(queryparam['Password']),
          SB_ID: queryparam['SB_ID']
        };

        let DataBody = JSON.stringify(LoginJson);
        sessionStorage.setItem('Tgsh@#3734fjfskshh==', '173.212.234.56');
        let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
        this.LoginService.PostLoginInfo(DataBody, 2, IpAddress).subscribe(
          (res: any) => {
            debugger;
            if (res.SubBrokerCode != '' && res.SubBrokerCode != null) {
              // console.log(res);
              if (this.IsOptimoney || environment.CompayName == 'IFA') {
                if (res.FIFO != 'Y') {
                  if (res.DOE == 'N') {
                    this.Loader.hide(); //added by adarsh 03052023
                    this.CallAlertModal('Access denied !!');
                    // window.location.reload();
                    //this.router.navigateByUrl('');
                    return;
                  }
                } else {
                  this.Loader.hide(); //added by adarsh 03052023
                  this.CallAlertModal(
                    'Access denied! Portfolio refresh and other mainteinance activity in progress. Please check after 30-60 minutes.'
                  );
                  // window.location.reload();
                  return;
                }
              }

              sessionStorage.setItem('ClientPDFSchedule', '1'); //Session_clientpdf

              sessionStorage.setItem(
                '`huR,8@RK9^??b4 -.hfs!!uR,XX',
                res.TOKEN_ID
              );
              sessionStorage.setItem(
                '5V5uSYBoBVqAvBIBqUEBhv6ELFF',
                this.EncrdecrService.setEncr('1')
              ); //Session_SubBrokerId

              sessionStorage.setItem(
                'F44sGAGh2xwkpUL',
                this.EncrdecrService.setEncr(res.LOGIN_ID)
              ); //Session_SubBrokerId
              sessionStorage.setItem(
                'V4WGROuLLBE6t98',
                this.EncrdecrService.setEncr(res.USER_NAME)
              ); //Session_UserName
              sessionStorage.setItem(
                'V8hpPfITcxhEI9x',
                this.EncrdecrService.setEncr(res.EMAIL_ID)
              ); //Session_UserEmail
              sessionStorage.setItem(
                'Xe003SRRyYEoOC2',
                this.EncrdecrService.setEncr(res.MOBILE)
              ); //Session_UserMobile
              if (
                res.RazorCustId !== null &&
                res.RazorCustId !== undefined &&
                res.RazorCustId !== 'null'
              ) {
                sessionStorage.setItem(
                  'pOWgAF62qFXnZMn',
                  this.EncrdecrService.setEncr(res.RazorCustId)
                ); //RazorCustId
              } else {
                sessionStorage.setItem('pOWgAF62qFXnZMn', ''); //RazorCustId
              }
              sessionStorage.setItem(
                'Hldq31TLYwRbLJ8',
                this.EncrdecrService.setEncr(res.SubBrokerCode)
              ); //Session_SubBrokerCode
              sessionStorage.setItem(
                'L2D3506kIHSk3E0',
                this.EncrdecrService.setEncr(res.USER_TYPE)
              ); //Session_UserType
              sessionStorage.setItem(
                'qAkZrQYLWNBSlki',
                this.EncrdecrService.setEncr(res.LOGIN_ID)
              ); //Session_CBId

              sessionStorage.setItem('pi4ZU2P3M8JE4q7', res.Companylogobase64); //Session_B64CompanyLogo

              //sessionStorage.setItem('Session_B64CompanyLogo_EtE',res.Companylogobase64);
              if (res.Family_ID != null && res.Family_ID != undefined) debugger;
              sessionStorage.setItem(
                'hn0bHyGhfpGtrPe',
                this.EncrdecrService.setEncr(res.Family_ID)
              ); //Session_Family_ID

              sessionStorage.setItem('Session_Exchange', res.Exchange);
              sessionStorage.setItem('Session_Cobranding', res.Cobranding); //added by adarsh
              sessionStorage.setItem('ihjt45h45=sb', res.SubBrokerCode); //added by adarsh for optimoney
              sessionStorage.setItem('ihjt45h45=p', res.SubBrokerCode); //added by adarsh for Optimoney

              //alert('Exchange = ' + res.Exchange);

              this.Loader.hide();
              switch (res.USER_TYPE) {
                case '2':
                  sessionStorage.setItem(
                    'm5JkoXISmYRAIuY',
                    this.EncrdecrService.setEncr(res.SubBrokerCode)
                  ); //Session_UserId

                  sessionStorage.setItem(
                    'm5JkoXISUSm5JkoER_Im5JkoD',
                    this.EncrdecrService.setEncr(res.USER_ID)
                  );
                  sessionStorage.setItem(
                    'N1QJHdOkO7SBNAME8QC',
                    this.EncrdecrService.setEncr(res.USER_NAME)
                  ); //Session_SubbrokerName added by adarsh 27092023
                  sessionStorage.setItem(
                    'N1QJHdOkO7SBMb8QC',
                    this.EncrdecrService.setEncr(res.MOBILE)
                  ); //Session_SubbrokerMB added by adarsh 27092023

                  if (res.RazorePaymentStatus) {
                    this.router.navigate(['/dashboard'], {
                      relativeTo: this.route
                    });
                  } else {
                    // this.Loader.hide();
                    //uncomment for payment
                    sessionStorage.setItem(
                      'nbj%98LS74nkjsn~@&4njrkd`!kd*294',
                      res.RazorePaymentStatus
                    );
                    this.router.navigate(['/reports/holding-report'], {
                      relativeTo: this.route
                    });

                    // sessionStorage.setItem('nbj%98LS74nkjsn~@&4njrkd`!kd*294', 'res.RazorePaymentStatus')
                    // this.router.navigate(['/dashboard'], { relativeTo: this.route });
                  }
                  break;
                case '3':
                  sessionStorage.setItem(
                    'm5JkoXISmYRAIuY',
                    this.EncrdecrService.setEncr(res.USER_ID)
                  ); //Session_UserId
                  sessionStorage.setItem(
                    'UZT6qHaDZSz66kx',
                    this.EncrdecrService.setEncr(res.LOGIN_ID)
                  ); //Session_ClientBasicInfoId
                  sessionStorage.setItem(
                    'N1QJHdOkO7Hz8QC',
                    this.EncrdecrService.setEncr(res.LOGIN_ID)
                  ); //Session_ClientBasicInfoId
                  sessionStorage.setItem(
                    'N1QJHdOkO7SBNAME8QC',
                    this.EncrdecrService.setEncr(res.SubbrokerName)
                  ); //Session_SubbrokerName added by adarsh 27092023
                  sessionStorage.setItem(
                    'N1QJHdOkO7SBMb8QC',
                    this.EncrdecrService.setEncr(res.SubbrokerMb)
                  ); //Session_SubbrokerMB added by adarsh 27092023
                  sessionStorage.setItem(
                    'RelationShipId',
                    this.EncrdecrService.setEncr(res.RelationShipId)
                  ); //Session_SubbrokerMB added by adarsh 16112023
                  this.router.navigate(['/client-dashboard'], {
                    relativeTo: this.route
                  });
                  break;
              }
            } else {
              this.CallAlertModal('Invalid username and password.');
            }
          },
          (err: any) => {
            //debugger;
            ////////
            //console.log(err)
            let rr = err.error;
            let er = rr.substring(1, rr.length - 1);
            let rk = er.split(', ');
            this.Loader.hide();
            if (rk[1].includes('Number of invalid login attempts')) {
              this.CallAlertModal(
                'Number of invalid login attempts. Your account is locked for 15 minutes'
              );
            } else {
              this.CallAlertModal('Please enter valid username and password');
            }
            ////console.log('err =>' + er);
          }
        );
      }
    });

    this.Loader.hide();
  }

  CallAlertModal(msg: any) {
    $('#AlertModal_Family').modal({
      backdrop: 'static',
      keyboard: false
    });
    $('#AlertModalContent_Family').text(msg);
  }
}
